export function TargetMulticulturalIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="language">
      <path id="Vector" d="M2.66667 16C2.66667 23.3638 8.6362 29.3333 16 29.3333C23.3638 29.3333 29.3333 23.3638 29.3333 16C29.3333 8.6362 23.3638 2.66667 16 2.66667C8.6362 2.66667 2.66667 8.6362 2.66667 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_2" d="M17.3333 2.73242C17.3333 2.73242 21.3333 7.99992 21.3333 15.9999C21.3333 23.9999 17.3333 29.2674 17.3333 29.2674" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_3" d="M14.6667 29.2674C14.6667 29.2674 10.6667 23.9999 10.6667 15.9999C10.6667 7.99992 14.6667 2.73242 14.6667 2.73242" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_4" d="M3.50521 20.6667H28.4929" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_5" d="M3.50521 11.3333H28.4929" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}
